var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigcalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 26149",
    x: 14.1562,
    y: 28.4219,
    width: 6.75,
    height: 4.21875,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.75 22.5H7.25M36.5 4.5V13.5M18.5 4.5V13.5M14.7188 28.4217V33.0625H20.3438V28.4217H14.7188ZM18.05 49.5H36.95C40.7305 49.5 42.6204 49.5 44.0645 48.7643C45.3346 48.1172 46.3672 47.0846 47.0143 45.8145C47.75 44.3705 47.75 42.4805 47.75 38.7V19.8C47.75 16.0196 47.75 14.1295 47.0143 12.6856C46.3672 11.4155 45.3346 10.3829 44.0645 9.73571C42.6204 9 40.7305 9 36.95 9H18.05C14.2696 9 12.3795 9 10.9356 9.73571C9.66547 10.3829 8.63285 11.4155 7.98571 12.6856C7.25 14.1295 7.25 16.0196 7.25 19.8V38.7C7.25 42.4805 7.25 44.3705 7.98571 45.8145C8.63285 47.0846 9.66547 48.1172 10.9356 48.7643C12.3795 49.5 14.2696 49.5 18.05 49.5Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigcalendarIcon);
export default __webpack_public_path__ + "static/media/bigcalendarIcon.63624ad999b428e83f7cfd17436aba8d.svg";
export { ForwardRef as ReactComponent };